var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.830078 13.1099V15.2399H11.1001V13.1099H0.830078ZM0.830078 0.919922V3.04992H5.00008V0.919922H0.830078ZM0.830078 7.00992V9.14992H8.05008V7.00992H0.830078Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4299 4.15992H17.0099V7.35992H15.3599V4.15992H12.9399L12.9999 4.08992L16.1599 0.949922L16.1899 0.919922L16.2099 0.949922L19.3599 4.08992L19.4299 4.15992Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7299 11.9898C16.6699 12.5098 15.8799 13.4698 15.6099 14.6598L12.9999 12.0698L12.9399 11.9898H15.3599V8.7998H17.0099V11.9898H17.7299V11.9898Z",
    fill: "#0096D6",
    stroke: "#0096D6",
    strokeWidth: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2603 16.3504L21.9203 17.0104L20.9403 17.9904L19.4803 16.5204L18.0203 17.9904L17.0503 17.0104L18.5103 15.5504L17.1903 14.2304L17.0503 14.0904L18.0203 13.1104L18.1703 13.2604L19.4803 14.5804L20.9403 13.1104L21.2603 13.4304L21.9203 14.0904L21.2603 14.7504L20.4503 15.5504L21.2603 16.3504Z",
    fill: "#D6002A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSort);
export default __webpack_public_path__ + "static/media/clear-sort.1956a8ba97b0d6cfe09d81f9b0e7db1a.svg";
export { ForwardRef as ReactComponent };